export default __webpack_public_path__ + "static/6-cd61503d306fc742b9d23ed090c9227a.webp";